// extracted by mini-css-extract-plugin
export default {"tableWrapper":"EydAcux","campaignDropdown":"n07zAxE","campaignDropdownWrapper":"Lyjgd2W"};